import { render, staticRenderFns } from "./himbauan_jemput_bola.vue?vue&type=template&id=1bb61e7e&"
import script from "./himbauan_jemput_bola.vue?vue&type=script&lang=js&"
export * from "./himbauan_jemput_bola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports